module.exports = __webpack_public_path__ + "img/team-04.1512b183.jpg";